export default __webpack_public_path__ + "static/media/new-logo-white.1b2e7113.png";